import { all, takeEvery } from 'redux-saga/effects';
import { fetchPackagingGroupsAction } from '../actions';
import { fetchPackagingGroupsSaga } from './fetchPackagingGroupsSaga';

export function* packagingGroupsWatcherSaga() {
  yield all([
    takeEvery(fetchPackagingGroupsAction.TYPE, fetchPackagingGroupsSaga),
  ]);
}
